import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import AffiliateAboutBanner from '../../assets/images/man-with-laptop.jpg';
import OrangeTick from '../../assets/icons/orange-tick.png';

const WhatsInItForYou = () => (
  <Box sx={{ backgroundColor: '#15B5E833' }}>
    <Box my={3} px={{ xs: 2, md: 10, lg: 20 }} pt={{ xs: 4, md: 8 }}>
      <Typography
        fontFamily="Lato"
        fontWeight="900"
        variant="h4"
        sx={{
          textAlign: 'center',
          letterSpacing: '0%',
          lineHeight: '100%',
        }}
      >
        What&apos;s in it for you?
      </Typography>

      <Typography
        pt={2}
        fontFamily="Lato"
        fontWeight="400"
        variant="body1"
        sx={{
          fontSize: '16px',
          lineHeight: '150%',
          letterSpacing: '0.5px',
          textAlign: 'center',
          px: { xs: 2, md: 10 },
        }}
      >
        Partnering with CanAm Excursions as an affiliate means more than just
        exposure—it’s a direct path to consistent revenue, increased bookings,
        and long-term growth. Here’s what you get when you join our program:
      </Typography>

      <Grid container rowSpacing={1} pt={2} spacing={5}>
        {/* Image Section */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              height: { xs: 'auto', md: '85vh' },
              maxHeight: '700px',
              display: { xs: 'flex', md: 'flex' },
              justifyContent: 'center',
              alignItems: 'center',
              my: 3,
              pl: { md: 5, lg: 10 },
              borderRadius: '40px',
              overflow: 'hidden',
              backgroundColor: '#f0f0f0',
            }}
          >
            <Box
              component="img"
              src={AffiliateAboutBanner}
              alt="Man working"
              sx={{
                maxHeight: '110%',
                maxWidth: '150%',
                width: '150%',
                height: '110%',
                objectFit: 'cover',
                objectPosition: 'top',
              }}
            />
          </Box>
        </Grid>

        {/* Text Section */}
        <Grid item xs={12} md={6}  px={{ xs: 2, md: 5 }} mt={{ md: -1}} pb={10}>
          {[
            {
              title: 'Earn Commission on Every Sale',
              text: `For every traveler that books one of our curated travel packages through your referral,
              you'll receive a competitive commission. Whether you're guiding a single-day adventure or hosting
              multi-day tours, your referrals are tracked and credited automatically.`,
            },
            {
              title: 'Boost Your Visibility',
              text: `Your excursions will be introduced to a broader, North American audience of travel enthusiasts
              actively booking experiences through CanAm. You'll benefit from increased exposure on our site,
              email campaigns, and partner listings.`,
            },
            {
              title: 'Marketing Tools & Support',
              text: `We'll provide you with a complete affiliate toolkit:
              • A personalized affiliate link and tracking code
              • Social media creatives and promotional content
              • Regular campaign updates and seasonal promotion ideas
              • Our team is here to help you market smarter, not harder.`,
            },
            {
              title: 'No Upfront Costs',
              text: `There's absolutely no cost to join. You earn commissions simply by promoting CanAm travel packages—no setup fees, no monthly charges.`,
            },
            {
              title: 'Transparent Tracking & Reporting',
              text: `Stay informed with real-time dashboards showing clicks, conversions, and earnings. You’ll always know exactly how your promotions are performing.`,
            },
          ].map((item, index) => (
            <Box key={index} pt={3}>
              <Typography
                variant="h7"
                fontFamily="Lato"
                fontWeight="900"
                lineHeight="100%"
                letterSpacing="0%"
              >
                <img
                  src={OrangeTick}
                  alt="Tick"
                  width={14}
                  height={13}
                  style={{ marginRight: '10px' }}
                />
                {item.title}
              </Typography>
              <Typography
                variant="subtitle1"
                fontSize="90%"
                fontWeight="400"
                lineHeight="150%"
                letterSpacing="0.5px"
                align="justify"
                mt={1}
                whiteSpace="pre-line"
              >
                {item.text}
              </Typography>
            </Box>
          ))}
        </Grid>
      </Grid>
    </Box>
  </Box>
);

export default WhatsInItForYou;
